import { useEffect } from 'react';
import { isFunction } from 'lodash/fp';
/**
 * Wrapper hook that executes some effect every time after the predicate
 * is met.
 *
 * @param {boolean|Function} predicate - boolean value or predicate to be
 * calculated.
 * @param {Function} effect - effect to be executed
 *
 * @example
 * useEffectWhen(() => 4 / 2 === 2, () => console.log('2)))
 * // => 2
 */

export default function useEffectWhen(predicate, effect) {
  var result = isFunction(predicate) ? predicate() : predicate;
  useEffect(function () {
    if (result && effect) {
      effect();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [result]);
}